import React, { useState } from "react";
import OffboardingDetails from "./ExitEmployeesTab/OffboardingDetails";
import OffboardingDocuments from "./ExitEmployeesTab/OffboardingDocuments";
import PendingTimesheets from "./ExitEmployeesTab/PendingTimesheets";
import PendingStatusReports from "./ExitEmployeesTab/PendingStatusReports";
import Leaves from "./ExitEmployeesTab/Leaves";
import OrganizationDocuments from "./ExitEmployeesTab/OrganizationDocuments";
import ResignationDetails from "./ExitEmployeesTab/ResignationDetails";
import WorkAuthorization from "./ExitEmployeesTab/WorkAuthorization";
import Communication from "./ExitEmployeesTab/Communication";
import {
  AdvSeparator,
  Avatar,
  Button,
  PageHeader,
  StatusTags,
  Tag,
} from "../../../../../components";
import RollbackOffBoarding from "./ExitEmployeesTab/Modals/RollbackOffBoarding";
import { useNavigate } from "react-router-dom";
import ExitEmployeeSendMail from "./ExitEmployeesTab/ExitEmployeeSendMail";

// const StaticSidebarMenu = ({ items, activeTab, setActiveTab }) => {
//   return (
//     <div className="bg-[#3A3A3A] h-full w-full flex flex-col  overflow-hidden ">
//       {items.map((item, index) => {
//         const isActive = activeTab === item.key;
//         const isFirst = index === 0;
//         const isLast = index === items.length - 1;

//         return (
//           <button
//             key={index}
//             onClick={() => setActiveTab(item.key)}
//             className={`flex items-center gap-3 px-6 py-3 w-full group transition-colors duration-150
//               ${
//                 isActive
//                   ? `bg-[#FF6A00]
//                       `
//                   : "hover:bg-[#4D4D4D]"
//               }`}
//           >
//             <span className="material-symbols-rounded text-[24px] font-thin text-white ">
//               {item.icon}
//             </span>
//             <span className="text-[15px] font-normal text-white">
//               {item.title}
//             </span>
//           </button>
//         );
//       })}
//     </div>
//   );
// };
const StaticSidebarMenu = ({ items, activeTab, setActiveTab }) => {
  return (
    <div className="bg-[#3A3A3A] h-full w-full flex flex-col overflow-hidden rounded-md">
      {items.map((item, index) => {
        const isActive = activeTab === item.key;
        const isFirst = index === 0;
        return (
          <button
            key={index}
            onClick={() => setActiveTab(item.key)}
            className={`flex items-center gap-3 px-6 py-3 w-full group transition-colors duration-150
              ${isFirst ? "mt-6" : ""}
              ${isActive ? "bg-[#FF6A00]" : "hover:bg-[#4D4D4D]"}
            `}
          >
            <span className="material-symbols-rounded text-[24px] font-thin text-white">
              {item.icon}
            </span>
            <span className="text-[15px] font-normal text-white">
              {item.title}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const sidebarMenuItems = [
  {
    key: "offboardingDetails",
    title: "Offboarding Details",
    icon: "detection_and_zone",
  },
  {
    key: "offboardingDocuments",
    title: "Offboarding Documents",
    icon: "user_attributes",
  },
  {
    key: "pendingTimesheets",
    title: "Pending Timesheets",
    icon: "pending_actions",
  },
  {
    key: "pendingStatusReports",
    title: "Pending Status Reports",
    icon: "work_history",
  },
  { key: "leaves", title: "Leaves", icon: "airline_seat_recline_extra" },
  {
    key: "organizationDocuments",
    title: "Organization Documents",
    icon: "cases",
  },
  {
    key: "resignationDetails",
    title: "Resignation Details",
    icon: "business_center",
  },
  {
    key: "workAuthorization",
    title: "Work Authorization",
    icon: "diversity_2",
  },
  {
    key: "communication",
    title: "Communication",
    icon: "connect_without_contact",
  },
];

const ExitEmployeesTab = () => {
  const [rollBackModal, setRollBackModal] = useState(false);
  const [sendMail, setSendMail] = useState(false);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("offboardingDetails");

  const renderTabContent = () => {
    switch (activeTab) {
      case "offboardingDetails":
        return <OffboardingDetails />;
      case "offboardingDocuments":
        return <OffboardingDocuments />;
      case "pendingTimesheets":
        return (
          <div>
            <PendingTimesheets />
          </div>
        );
      case "pendingStatusReports":
        return (
          <div>
            <PendingStatusReports />
          </div>
        );
      case "leaves":
        return (
          <div>
            <Leaves />
          </div>
        );
      case "organizationDocuments":
        return (
          <div>
            <OrganizationDocuments />
          </div>
        );
      case "resignationDetails":
        return (
          <div>
            <ResignationDetails />
          </div>
        );
      case "workAuthorization":
        return (
          <div>
            <WorkAuthorization />
          </div>
        );

      case "communication":
        return (
          <div>
            <Communication />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col">
      <div className="py-2">
        <PageHeader
          Section={
            <div className="flex items-center gap-2  flex-1">
              <div>
                <Avatar size="xxl" src={""} alt={"Abhiram Tayi"} />
              </div>
              <div className="flex justify-start items-center gap-4 flex-1">
                <div>
                  <div className="flex gap-2 items-center">
                    <h4 className="subtitle-reg">Abhiram Tayi</h4>
                    <Tag
                      title={"EMP-1003"}
                      variant="outlined"
                      color="warning"
                      className=" !text-neutrals !py-1"
                    />
                  </div>
                  <AdvSeparator minItemsPerRow={4}>
                    <span className="body-two text-neutrals leading-none">
                      abhiramqa@gmail.com
                    </span>
                    <span className="body-two text-neutrals leading-none">
                      515-306-6635
                    </span>
                    <span className="body-two text-neutrals leading-none">
                      Employee
                    </span>
                    <StatusTags title="Exit" variant="text" tag="Exit" icon />
                  </AdvSeparator>
                </div>
              </div>
            </div>
          }
          RightSection={
            <div className="flex gap-2">
              <Button
                title="Back"
                icon="arrow_left_alt"
                onClick={() => navigate("/payroll/pay-data-center")}
              />
              <Button
                title="Rollback Offboarding"
                icon=""
                onClick={() => setRollBackModal(true)}
              />
              <Button
                title="Send Mail"
                icon=""
                onClick={() => setSendMail(!sendMail)}
              />
              <Button title="Notes" icon="" />
            </div>
          }
        />
      </div>
      <div className="flex min-h-[80vh]">
        <div className="w-[250px] bg-[#3A3A3A] rounded-sm">
          <StaticSidebarMenu
            items={sidebarMenuItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
        <div className="flex-1 p-4 border-[1px] border-neutrals-100 ml-2 rounded-md overflow-hidden shadow-md">
          {/* {renderTabContent()} */}
          {sendMail ? <ExitEmployeeSendMail /> : renderTabContent()}
        </div>
      </div>
      <RollbackOffBoarding
        isOpen={rollBackModal}
        onClose={() => setRollBackModal(false)}
      />
    </div>
  );
};

export default ExitEmployeesTab;
